#import "./StaffQuizAttemptFields.graphql"

mutation SubmitTrainingQuizAttempt(
  $attemptId: ID!
  $answers: [QuizAnswerInput!]!
) {
  submitTrainingQuizAttempt(
    input: { attemptId: $attemptId, answers: $answers }
  ) {
    attempt {
      ...StaffQuizAttemptFields
    }
  }
}
